<template>
  <div>
    <span v-html="activityMessage"></span>
  </div>
</template>

<script>
export default {
  name: 'TableFieldUpdated',
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityMessage() {
      const actor = this.activity?.actorUser?.name || 'Bilinmeyen Kullanıcı';
      const tableName = this.activity?.payload?.tableName || 'İsimsiz Tablo';
      const fieldName = this.activity?.payload?.fieldName || 'İsimsiz Alan';
      
      return this.$t('notification.tableFieldUpdated', {
        actor: `<strong>${actor}</strong>`,
        tableName: `<strong>${tableName}</strong>`,
        fieldName: `<strong>${fieldName}</strong>`
      });
    }
  }
};
</script>

<style scoped>
</style>

